module.exports = __webpack_public_path__ + "static/media/olivia-appleton.a7552942.jpg";